export const BIG_SELLER_LOGO: Record<string, string> = {
  'MyWit Japan': '/img/product/jp/sellerLogo/MyWiT Japan.png',
  sofmap: '/img/product/jp/sellerLogo/sofmap.jpg',
  エムコム: '/img/product/jp/sellerLogo/エムコム.png',
  スマホ専門販売店モバステ:
    '/img/product/jp/sellerLogo/スマホ専門販売店モバステ.png',
  にこスマ: '/img/product/jp/sellerLogo/にこスマ.jpg',
  ハピネスネット: '/img/product/jp/sellerLogo/ハピネスネット.png',
  株式会社イオシス: '/img/product/jp/sellerLogo/株式会社イオシス.png',
  株式会社エイティーワントレード:
    '/img/product/jp/sellerLogo/株式会社エイティーワントレード.png',
}
